import React from 'react';
import _ from 'lodash'
import {tableSpec} from './tables.js'
//import { Chart } from 'react-google-charts';
import { LineChart, PieChart, ColumnChart } from 'react-chartkick';

//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
let charts = function(paneName, graphPercentData, graphNumberData) {
  function computeGD(chartInfo) {
    var gd = _.cloneDeep(chartInfo.usePercent ? graphPercentData : graphNumberData)
    if (gd[0][0] === 'All') gd[0][0] = '';

    var maxLines = chartInfo.maxLines || 999
    if (gd[0].length > maxLines) {
      gd = _.map(gd, function(row) {return row.slice(0,maxLines)})
    }

    if (chartInfo.skipRow1) {
      _.forEach(gd, function(row) {row.splice(1,1)})
    }

    gd = _.filter(gd, function(row, index) {
      return index===0 || _.includes(chartInfo.years, row[0])
    })

    if (chartInfo.type === 'geo') {
      gd[0] = _.map(gd[0], function(name) {
        var english = chartInfo.table[name]
        if (english) return english
        return 'ES'
      })
      gd = _.zip.apply(_, gd)
    } else if (chartInfo.type === 'pie3') {
      gd = _.zip.apply(_, gd)
    }
    return gd;
  }

  let currentOption = tableSpec[paneName];
  let charts = [];

  window.Chart = require('chart.js');

  _.forEach(currentOption.charts, function(chartInfo, index) {

    let gd = computeGD(chartInfo)
  //  console.log('gd', gd)
    let gd1 = [];
    let months = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
    let months2 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let maxValue, ytitle, suffix, width, height, curve, titles, minValue;

    switch (chartInfo.type) {
      case 'lines':
      titles = chartInfo.titles;
      if (!titles) titles = months2;

      maxValue = 0;
      minValue = 999999;
      gd1 = gd.slice(1).map(arr => {
        return {
          "name":arr[0],
          "data":arr.slice(1).map((v,j) => {
            if (v > maxValue) maxValue = v;
            if (v < minValue) minValue = v;
            return [titles[j],v];
          })
        }
      })

      ytitle = chartInfo.ytitle;
      if (!ytitle) ytitle = '';
      suffix = chartInfo.suffix;
      if (!suffix) suffix = '';
      width = chartInfo.width;
      if (!width) width = '100%';
      height = chartInfo.height;
      if (!height) height = 400;
      curve = chartInfo.curve;
      if (curve!==false) curve = true;
      //minValue = chartInfo.minValue;
      //if (!minValue) minValue = 0;

      charts.push(
        <LineChart
          key={index}
          curve={curve}
          ytitle={ytitle}
          suffix={suffix}
          width={width}
          height={height+'px'}
          data={gd1}
          min={minValue}
          max={maxValue}
          legend="bottom"
          id="LineChart"
          thousands=","
        />
      );
      break

      case 'columns':
      gd1 = gd[1].slice(1).map((v,i) => [months2[i],v])
      console.log('columns: data:', gd1)
      charts.push(
        <ColumnChart
          key={index}
          data={gd1}
          label={'ColumnChart'}
          id="BarChart"
          library={{}}
          min={0}
          mac={70000}
          width="700px"
          height={'500px' /*chartInfo.height+'px'*/}
        />
      );
      break

      default:
      case 'pie3': {
        gd1 = gd[1].slice(1).map((v,i) => [months[i],v])
        //console.log('pie3: data:', gd1)
        charts.push(
          <PieChart
            key={index}
            data={gd1}
            label={'PieChart'}
            id="PieCharta"
            width="100%"
            height={chartInfo.height+'px'}
          />
        );
        /*element = document.getElementById('#'+chartInfo.type + index + '-a')
        chart = new google.visualization.PieChart(element)
        options.title = gd[0][1]
        chart.draw(chartData, options);

        element = document.getElementById('#'+chartInfo.type + index + '-b')
        chart = new google.visualization.PieChart(element)
        _.forEach(gd, function(row) {row.splice(1,1)})
        options.title = gd[0][1]
        chartData = new google.visualization.arrayToDataTable(gd);
        chart.draw(chartData, options);

        element = document.getElementById('#'+chartInfo.type + index + '-c')
        chart = new google.visualization.PieChart(element)
        _.forEach(gd, function(row) {row.splice(1,1)})
        options.title = gd[0][1]
        chartData = new google.visualization.arrayToDataTable(gd);
        chart.draw(chartData, options);*/
        break
      }

      case 'geo':
      /*chart = new google.visualization.GeoChart(chartDiv)
      options.region = chartInfo.region
      chart.draw(chartData, options);*/
      console.log('*** ERROR: not geo chart')
      break

    }
  })
  return charts;
}

export {charts};



// WEBPACK FOOTER //
// ./src/charts.js